import { accountBadgeEntityName } from '../../../../backend/features/badges/shared';
import { useStorageClient } from '@juvare/platform-sdk-react/ui/hooks';
export const useAccountBadgeStorage = () => {
    return useStorageClient(accountBadgeEntityName);
};
